import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useState, useEffect } from "react";

import Navbar from "./components/Homepage/Navbar";
import Homepage from "./components/Homepage/Homepage";
import Aboutpage from "./components/About/Aboutpage";
import Footer from "./components/Homepage/Footer";
import ContactPage from "./components/Contact/Contact";
import Accounting from "./components/services/Accounting";
import Consulting from "./components/services/Consulting";
import Grants from "./components/services/Grants";
import Taxes from "./components/services/Taxes";
import BlogList from "./components/Blog/BlogList";

import ScrollToTop from "./components/components/ScrollToTop";
import LogoLoader from "./components/components/LogoLoader";
import NewRouteLoader from "./components/components/NewRouteLoader";
import circle from "./media/aspenseparated/circle.svg";

function AppWrapper() {
  const [showInitialRouteLoader, setShowInitialRouteLoader] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const routeTimer = setTimeout(() => {
      setShowInitialRouteLoader(false);
    }, 2000);

    const logoTimer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => setInitialLoading(false), 500);
    }, 5000);

    return () => {
      clearTimeout(routeTimer);
      clearTimeout(logoTimer);
    };
  }, []);

  // Initial manual white screen + circle
  if (showInitialRouteLoader) {
    return (
      <div className="new-route-loader">
        <img src={circle} alt="Loading" className="new-route-loader-img" />
      </div>
    );
  }

  // Logo animation splash
  if (initialLoading) {
    return (
      <div className={fadeOut ? "fade-out-loader" : ""}>
        <LogoLoader />
      </div>
    );
  }

  // ✅ Mount Router ONLY after both loaders are finished
  return (
    <Router>
      <RouteTransitionLayout />
    </Router>
  );
}

function RouteTransitionLayout() {
  const location = useLocation();

  return (
    <>
      <NewRouteLoader />
      <ScrollToTop />
      <Navbar />
      <Routes location={location}>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<Aboutpage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/accounting" element={<Accounting />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/grants" element={<Grants />} />
        <Route path="/taxes" element={<Taxes />} />
        <Route path="/bloglist" element={<BlogList />} />
      </Routes>
      <Footer />
    </>
  );
}

export default AppWrapper;
